import { render, staticRenderFns } from "./DetailsTeaser.vue?vue&type=template&id=7ebcb8b7&scoped=true"
import script from "./DetailsTeaser.vue?vue&type=script&lang=js"
export * from "./DetailsTeaser.vue?vue&type=script&lang=js"
import style0 from "./DetailsTeaser.vue?vue&type=style&index=0&id=7ebcb8b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebcb8b7",
  null
  
)

export default component.exports